import { LinkOutbound } from '@/components/common/Link'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type RecType } from '@/defs/rec'
import { formatFullNumber, formatPercentage } from '@/utils/formatUtil'
import { getRecName } from '@/utils/recUtil'

type Props = {
  rec: RecType
}

export const StatRecInclusionTooltip = ({ rec }: Props) => {
  const fullName = getRecName(rec)
  const { inclusion, numDecks, potentialDecks } = rec

  return (
    <>
      <h2>
        <IconWithLabel iconBefore='percent'>Inclusion</IconWithLabel>
      </h2>

      <p>
        <strong>{fullName}</strong> is included in <strong>{formatFullNumber(numDecks ?? 0)}</strong> of{' '}
        <strong>{formatFullNumber(potentialDecks ?? 0)}</strong> (<strong>{formatPercentage(inclusion ?? 0)}%</strong>){' '}
        <LinkOutbound href='/faq#potential-decks'>potential decks</LinkOutbound>.
      </p>
    </>
  )
}
